/** Pick the first MediaRecorder mime type the browser actually supports. */
export function pickSupportedAudioMime() {
  if (typeof MediaRecorder === "undefined") return null;
  // Order of preference — webm/opus is best for Whisper, mp4/aac is iOS Safari's default
  const candidates = [
    "audio/webm;codecs=opus",
    "audio/webm",
    "audio/ogg;codecs=opus",
    "audio/mp4",
    "audio/mp4;codecs=mp4a.40.2",
    "audio/mpeg",
  ];
  for (const c of candidates) {
    try { if (MediaRecorder.isTypeSupported(c)) return c; } catch (_) { /* ignore */ }
  }
  return null; // let the browser pick its own default
}

/** Map a MIME type (from MediaRecorder.mimeType or a Blob.type) to a Whisper-accepted file extension. */
export function extForMime(mime) {
  if (!mime) return "webm";
  const m = String(mime).toLowerCase();
  if (m.includes("webm")) return "webm";
  if (m.includes("ogg")) return "ogg";
  if (m.includes("mp4") || m.includes("aac")) return "mp4";
  if (m.includes("mpeg") || m.includes("mp3")) return "mp3";
  if (m.includes("wav")) return "wav";
  return "webm";
}
